import konaInput from '@/tag/konaInput';
import konaSelect from '@/tag/konaSelect';
import konaTable from '@/tag/konaTable';
import vKonaSelect from "@/tag/vKonaSelect.vue";

export default {
    install(app) {
        app.component('kona-input', konaInput);
        app.component('kona-select', konaSelect);
        app.component('v-kona-select', vKonaSelect);
        app.component('kona-table', konaTable);
    }
}